import secureApi from "../services/secureApi";

export const getPermissionListApi = async () => {
  const response = await secureApi.get("/admin/permissions/list");

  return response.data;
};